export default __webpack_public_path__ + "static/alex-ivashenko-RLdcScGQEJ4-unsplash-d1afeae7b94e40e55f960c42d854afa0.jpg";